import * as Sentry from "@hy-sentry/browser";

/**
 * 参数 join 字符串
 */
function safeJoin(input: any[], delimiter: string) {
  const output: string[] = [];
  input.forEach((value) => {
    try {
      output.push(String(value));
    } catch (e) {
      output.push("[value cannot be serialized]");
    }
  });
  return output.join(delimiter);
}

/**
 * level 转换
 */
function fromLevel(level: string) {
  switch (level) {
    case "warn":
    case "warning":
      return Sentry.Severity.Warning;
    case "info":
      return Sentry.Severity.Info;
    case "error":
      return Sentry.Severity.Error;
    default:
      return Sentry.Severity.Log;
  }
}

export default function (sentry: typeof Sentry, sdk: any, debug?:boolean) {
  const Tag = "[Console Proxy]";
  try {
    ["debug", "info", "warn"].forEach((level) => {
      const orignProp = sdk[level];
      orignProp && Object.defineProperty(sdk, level, {
        value: (...params) => {
          orignProp.apply(sdk, params);
          // 添加到sentry
          try {
            if (params[0].startsWith(Tag)) return;
            sentry.addBreadcrumb({
              category: "logger",
              data: {
                arguments: params,
                logger: "hyExt.logger",
              },
              level: fromLevel(level),
              message: safeJoin(params, " "),
            });
          } catch (err) {
            debug && console.warn(`${Tag} add fail`, err.message);
          }
        },
      });
    });
  } catch (err) {
    debug && console.warn(`${Tag} init fail`, err.message);
  }
}
